'use strict';

exports.__esModule = true;
exports.validateTagValueByIdentifier = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _TagSchemas = require('../../types/TagSchemas');

var _Errors = require('../../types/Errors');

var _buildTagByValue = require('../utils/build-tag-by-value');

var validateTagValueByIdentifier = exports.validateTagValueByIdentifier = function validateTagValueByIdentifier(identifier, value, userValidators) {
  var tag = (0, _buildTagByValue.buildTagByValueAndIdentifier)(value, identifier);
  var tagSchemaValidator = function tagSchemaValidator() {
    return _TagSchemas.TAG_SCHEMAS[identifier].setValue(tag, value);
  };
  var validators = [].concat(userValidators || [], tagSchemaValidator);

  var invalidValidatorIndex = validators.findIndex(function (validator) {
    if (typeof validator === 'function') {
      var currentValidatorValue = validator(value);
      return !currentValidatorValue || (typeof currentValidatorValue === 'undefined' ? 'undefined' : _typeof(currentValidatorValue)) === 'object' && !currentValidatorValue.isValid;
    }
    return true;
  });

  var invalidValidator = validators[invalidValidatorIndex];
  return invalidValidator ? {
    isValid: false,
    error: typeof invalidValidator === 'function' && invalidValidator(value).error || new _Errors.ERRORS.CUSTOM_VALIDATOR(invalidValidatorIndex)
  } : { isValid: true };
};